import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'
import parserFilters from '@/utils/parserFilters'
import parserSlug from '@/utils/parserSlug'

Vue.use(Vuex)

const state = {
  reports: [],
  pagination: {
    currentPage: 1,
    perPage: 5,
    totalReports: 0,
    totalPages: 0
  },
  reportsCatalog: {},
  filterParams: '',
  isModalVisible: false
}

const mutations = {
  SET_REPORTS (state, payload) {
    state.reports = payload.data.data

    state.pagination = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      totalReports: payload.total,
      totalPages: payload.last_page
    }
  },
  ADD_REPORT (state, payload) {
    state.reports.unshift(payload)
  },
  UPDATE_REPORT (state, payload) {
    const idx = state.reports.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.set(state.reports, idx, payload)
    }
  },
  DELETE_REPORT (state, payload) {
    const idx = state.reports.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.reports, idx)
    }
  },
  DELETE_REPORTS (state, payload) {
    for (let id of payload.ids) {
      const idx = state.reports.findIndex(u => u.id === id)

      if (idx >= 0) {
        Vue.delete(state.reports, idx)
      }
    }
  },
  SET_MODAL_VISIBLE (state, payload) {
    state.isModalVisible = payload
  },
  SET_FILTER_PARAMS (state, payload) {
    state.filterParams = payload
  },
  SET_CATALOG (state, { object, payload }) {
    state.reportsCatalog[object] = payload.data
  },
  SET_REPORTS_CATALOG (state, payload) {
    state.reportsCatalog = { ...state.reportsCatalog, ...payload }
  }
}

const actions = {
  printReport ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(axios.defaults.baseURL + '/services/report')
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  printReportProfits ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(axios.defaults.baseURL + '/services/report/profits?' + state.filterParams)
    } catch (e) {
      console.log(e)
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  applyFilter ({ commit }, payload) {
    const filter = parserFilters(payload)
    commit('SET_FILTER_PARAMS', filter)
  },
  clearFilter ({ commit }, payload) {
    const filter = ''
    commit('SET_FILTER_PARAMS', filter)
  },
  async loadCatalog ({ commit }, payload) {
    let url = parserSlug(payload.url)
    app.$Progress.start()
    try {
      const response = await axios.get(`${url}${payload.filter}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CATALOG', { object: payload.url, payload: response.data })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  // async loadReportsCatalog ({ commit }, payload) {
  //   app.$Progress.start()
  //   try {
  //     const response = await axios.get(`reports/catalog`)
  //     const checkErrors = checkResponse(response)

  //     if (checkErrors) {
  //       app.$Progress.fail()
  //       commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.reports', text: checkErrors.message }, { root: true })
  //     } else {
  //       commit('SET_REPORTS_CATALOG', response.data)
  //     }
  //   } catch (e) {
  //     app.$Progress.fail()
  //     commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
  //   } finally {
  //     app.$Progress.finish()
  //   }
  // },
  setModalVisible ({ commit }, payload) {
    commit('SET_MODAL_VISIBLE', payload)
  },
  setModalImportVisible ({ commit }, payload) {
    commit('SET_MODAL_IMPORT_VISIBLE', payload, { root: true })
  }
}

const getters = {
  reports: state => state.reports,
  reportsCatalog: state => state.reportsCatalog,
  pagination: state => state.pagination,
  isModalVisible: state => state.isModalVisible,
  filterParams: state => state.filterParams
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
